import axios from "axios";
import Vue from "vue";

import SmartSocket from "@/../submodules/vue-base/js/SmartSocket";

var socket=undefined;

const state = {
	
	editingState: {},
	userIsEditing: false,
	userNeedsToLoadList: false,
	userNeedsToLoadListArchived: false,

};

const actions = {

	async loadEditingState(context){
		var connection = "wss";

		if(location.protocol != 'https:'){
			connection = "ws";
		}

		socket = new SmartSocket(
			connection + "://" + window.location.host + "/api/1/editingState",
			function(message){
				var new_state = JSON.parse(message.data);
				context.commit("setEditingState",new_state)
			}
		);


	},

    async addEditingState(context, data){

		if (socket.closed) {
			actions.loadEditingState(context);
		}

		var obj = {
			action: "add",
			data: data
		}
		
		var message = JSON.stringify(obj)

		socket.send(message);
	},

	async removeEditingState(context, editing_id){

		var obj = {
			action:"remove",
			id: editing_id,
		}
		socket.send(JSON.stringify(obj));
	},

	async leaveEditingState(context, info){

		var obj = {
			action:"leave",
			info: info,
		}
		socket.send(JSON.stringify(obj));
	},

	closeEditingState(context){
		socket.close();
	},

	editingStateEvent(context,event){
		context.commit("setEditingState",event.editingState)
	},

	sessionChangeEvent(context, event){
		if(event.username==context.rootState.user.user.ulog){
			window.location = "/signout";
		}
	},


	admissionFieldUpdateEvent(context,event){

		var list_id = event.list_id;
		var admission_id = event.admission_id;
		var field = event.field;

		var editing_id = admission_id + field;

		var user_id = event.user_id;
		
		if(context.rootState.user.user.uid==user_id){
			//in this case we made the change ourself so we will do nothing
			return;
		}

		if(context.rootState.list.currentList.list_id == list_id&&context.rootState.admissions.admissionsParams.list_id&&event.field=="admission_order"||event.field=="admission_section"){

			if(state.userIsEditing){
				actions.userNeedsToLoadList(context);
			}else{
				context.dispatch("loadAdmissions");
			}

		}
	
	},

	rankChangeEvent(context,event){
		var list_id = event.list_id;

		if(context.rootState.list.currentList.list_id == list_id&&context.rootState.admissions.admissionsParams.list_id){

			if(state.userIsEditing){
				actions.userNeedsToLoadList(context);
			}else{
				context.dispatch("loadAdmissions");
			}

		}
	},

	admissionArchiveEvent(context,event){

		var list_id = event.list_id;
		
		if(context.rootState.list.currentList.list_id == list_id){

			if(state.userIsEditing){
				actions.userNeedsToLoadListArchived(context);
			}else{
				context.dispatch("loadAdmissions");
			}

		}
	},

	userStartEditing(context){
		context.commit("setUserIsEditing", true);
	},

	userStopEditing(context){
		context.commit("setUserIsEditing", false);
	},

	userNeedsToLoadList(context){
		context.commit("setUserNeedsToLoadList", true);
	},

	userNeedsToLoadListArchived(context){
		context.commit("setUserNeedsToLoadListArchived", true);
	},


	userHasLoadedList(context){
		context.commit("setUserNeedsToLoadList", false);
		context.commit("setUserNeedsToLoadListArchived", false);
	},
	
}

const mutations = {
	setEditingState(state,data){
		state.editingState = data;

		// for(var key in state.editingState){
		// 	Vue.set(state.editingState, key, data[key]);
		// }

		// for(var key in data){
		// 	Vue.set(state.editingState, key, data[key]);
		// }

	},

	setUserIsEditing(state,editing){
		state.userIsEditing = editing;
	},

	setUserNeedsToLoadList(state,value){
		state.userNeedsToLoadList = value
	},
	setUserNeedsToLoadListArchived(state,value){
		state.userNeedsToLoadListArchived = value
	}
}

const getters = {
	editingState(state){
		return state.editingState;
	},
	userIsEditing(state){
		return state.userIsEditing;
	},
	userNeedsToLoadList(state){
		return state.userNeedsToLoadList;
	},
	userNeedsToLoadListArchived(state){
		return state.userNeedsToLoadListArchived;
	}
};
  

export default {
    state,
    actions,
    mutations,
    getters
};